<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="deliveryLocationsField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeDeliveryLocationsField] ? 'Exclude' : 'Include')} Delivery Locations`"
      :options="deliveryLocations.data"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one delivery location'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeDeliveryLocationsField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITIONS_REQUIREMENTS } from 'src/models/tip/TipShareRule'

export default {
  name: 'DeliveryLocationsConditionForm',
  configuration: ['deliveryLocations'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    deliveryLocationsField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.DELIVERY_LOCATIONS
    },
    excludeDeliveryLocationsField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.EXCLUDE_DELIVERY_LOCATIONS
    }
  }
}

</script>
